/* eslint-disable react-hooks/exhaustive-deps */
import { format } from "date-fns";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import PrimaryButton from "../../../../components/_utils/CommonButtons/PrimaryButton";
import TopNavComponent from "../../../../components/_utils/CommonTopNav/TopNavComponent";
import PaginationComponent from "../../../../components/_utils/PaginationComponent";
import SVGComponent from "../../../../components/_utils/SVGComponent";
import TransactionCard from "../../../../components/BulkuploadViewAll/BulkUploadCard";
import Loader from "../../../../components/Loader/Index";
import { beneCategories } from "../../../../redux/features/beneficiary/beneAllVerification/beneAllVerification";
import { bulkUploadViewAll } from "../../../../redux/features/beneficiary/beneTxnViewAccData/beneTxnViewAccData";
import {
  disableSwitcher,
  enableSwitcher,
} from "../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher";
import {
  GlobalConfiguration,
  IntervalConfiguration,
  PaginationConfiguration,
} from "../../../../utils/configurationProvider";
import useCategories from "../../../../utils/useCategories";
import useCustomSearchParams from "../../../../utils/useCustomSearchParams";
import "./index.css";

const BulkTransactionViewAll = ({ popType, categoryPass }) => {
  const navigate = useNavigate();
  const categoryMapper = useCategories();
  const dispatch = useDispatch();
  const FilterApplied = false;
  const FilterSidebarOpen = false;
  const dropdownOptions = PaginationConfiguration.paginationOptions;
  const { searchParam, handleSearchParams, handleClearSearchParam } =
    useCustomSearchParams({
      pageno: GlobalConfiguration.lengthCheckOne,
      pagesize: dropdownOptions[0],
    });
  const [, setIsOpen] = useState(false);
  const [showInnerSearchBar, setShowInnerSearchBar] = useState(false);
  const [searchUserTextDebounce, setSearchUserTextDebounce] = useState("");
  const [showSearch, setShowSearch] = useState(false);
  const [txnSearchType, setTxnSearchType] = useState(
    searchParam.get("search") || "",
  );
  const [currentStatus, setCurrentStatus] = useState(
    searchParam.get("status") || "",
    "",
  );
  const [currentCategory, setCurrentCategory] = useState(
    categoryPass ? categoryPass : searchParam.get("category") || "",
    "",
  );

  const [pageSize, setPageSize] = useState(
    searchParam.get("pagesize") || dropdownOptions[0],
  );
  const [selectedValue, setSelectedValue] = useState(
    searchParam.get("pagesize") || dropdownOptions[0],
  );
  const [currentPage, setCurrentPage] = useState(
    searchParam.get("pageno") || GlobalConfiguration.lengthCheckOne,
  );

  const [loading, setLoading] = useState(false);
  const [viewAllData, setViewAllData] = useState([]);
  const [mainData, setMainData] = useState([]);
  const [active, setActive] = useState("");
  const [loadingData, setLoadingData] = useState(false);
  const [inputData, setInputData] = useState([]);

  const handleSearch = (text) => {
    setSearchUserTextDebounce(text);
  };

  const convertDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const timestamp = Math.floor(
      date.getTime() / IntervalConfiguration.intervalMedium,
    );
    return timestamp;
  };

  const [startDateFilter, setStartDateFilter] = useState(
    convertDate(searchParam.get("date")?.split(",")?.[0]) || "",
  );
  const [endDateFilter, setEndDateFilter] = useState(
    convertDate(searchParam.get("date")?.split(",")?.[1]) || "",
  );

  const handleClearParams = useCallback(
    (e) => {
      handleClearSearchParam();
      e?.stopPropagation();
      setCurrentCategory(categoryPass ? categoryPass : "");

      setStartDateFilter("");
      setEndDateFilter("");

      setTxnSearchType("");
      setSearchUserTextDebounce("");
      setCurrentStatus("");
      // Clear search state
      if (setShowSearch) {
        setShowSearch(false);
      }

      if (setTxnSearchType) {
        setTxnSearchType("");
      }
    },
    [setShowSearch, setTxnSearchType],
  );

  // Pagination handlers
  const handleSelect = useCallback((value) => {
    handleSubmit("pagesize", value);
    setCurrentPage(GlobalConfiguration.lengthCheckOne);

    setSelectedValue(value);
    setPageSize(value);
  }, []);

  const handlePagination = useCallback((page) => {
    handleSubmit("pageno", page);
    setCurrentPage(page);
  }, []);

  const handleDateChange = (date) => {
    if (date) {
      const [start, end] = date;
      setStartDateFilter(convertDate(start));
      setEndDateFilter(convertDate(end));
    } else {
      setStartDateFilter("");
      setEndDateFilter("");
    }
  };

  const hasActiveFilters = useMemo(
    () => currentCategory !== "" || startDateFilter || endDateFilter,
    [currentCategory, startDateFilter, endDateFilter],
  );

  const containerClassName = useMemo(
    () =>
      ` ${popType === "BulkUploadDetails" ? "h-full" : "h-screen"} overflow-y-hidden`,
    [FilterSidebarOpen],
  );

  const contentClassName = useMemo(
    () =>
      `${
        FilterSidebarOpen
          ? `opacity-dark-opacity  ${
              popType === "BulkUploadDetails"
                ? "bulkUploadViewAllheightPopup"
                : "bulkUploadViewAllheight"
            } `
          : `w-full h-screen  ${popType === "BulkUploadDetails" && "h-full flex-1"} ${
              showSearch && FilterApplied
                ? ` ${
                    popType === "BulkUploadDetails" ? "" : "Qmd:pb-padding-sm "
                  } ${
                    popType === "BulkUploadDetails"
                      ? "bulkUploadViewAllheightfilterSerchpopup"
                      : "bulkUploadViewAllheightfilterSerch"
                  } `
                : showSearch || FilterApplied
                  ? ` ${
                      popType === "BulkUploadDetails"
                        ? "Qmd:pb-padding-md"
                        : "Qmd:pb-padding-sm "
                    } ${
                      popType === "BulkUploadDetails"
                        ? "bulkUploadViewAllSerchorFilterpopup"
                        : ""
                    }`
                  : `${
                      popType === "BulkUploadDetails"
                        ? "Qmd:pb-padding-md "
                        : ""
                    } `
            } mb-[var(--pagination-height)]  mx-auto ${showInnerSearchBar ? "overflow-y-hidden" : "overflow-y-auto"} ${
              popType === "BulkUploadDetails"
                ? "bulkUploadViewAllheightPopup"
                : "h-screen"
            }`
      }`,
    [FilterSidebarOpen, showSearch, FilterApplied, showInnerSearchBar],
  );

  const handleSubmit = (key, value) => {
    if (popType !== "BulkUploadDetails") {
      handleSearchParams(key, value);
    }
  };

  const handleNavigate = useCallback(
    (path) => {
      navigate(path);
    },
    [navigate],
  );

  const fetchFilterData = async () => {
    let response;
    let data = [];

    setLoadingData(true);

    switch (active) {
      case "Category":
        response = await dispatch(
          beneCategories({ search_string: searchUserTextDebounce }),
        );

        data =
          response?.payload?.categories?.map((itm) => ({
            id: itm.name,
            Category: itm.name,
            Description: itm?.description || "Not given",
          })) || [];

        setInputData(data);
        setLoadingData(false);
        break;

      case "Search":
        setTxnSearchType(searchUserTextDebounce);
        setLoadingData(false);
        break;

      default:
        break;
    }
  };

  const formatDateForAPI = (date) => {
    const dateObj = new Date(date * 1000);
    return format(dateObj, "dd-MM-yyyy");
  };
  const { markerData } = useSelector((s) => s.multiEntitySwitcherSlice);

  const fetchData = async () => {
    try {
      setLoading(true);

      let queryParams = {
        page_no: currentPage,
        page_item_count: pageSize,
      };

      if (currentStatus && currentStatus !== "all") {
        queryParams.currentStatus = currentStatus;
      }
      if (currentCategory && currentCategory !== "") {
        queryParams.initCategory = currentCategory;
      }
      if (txnSearchType !== "") {
        queryParams.file_name = txnSearchType;
      }
      if (
        startDateFilter &&
        endDateFilter &&
        !isNaN(Number(startDateFilter)) &&
        !isNaN(Number(endDateFilter))
      ) {
        queryParams.start_date = formatDateForAPI(startDateFilter);
        queryParams.end_date = formatDateForAPI(endDateFilter);
      }

      const response = await dispatch(bulkUploadViewAll(queryParams));

      setMainData(response?.payload);
      const newData = response?.payload?.transactions_file || [];
      setViewAllData(newData);
    } catch (error) {
      setViewAllData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [
    dispatch,
    currentPage,
    pageSize,
    currentStatus,
    currentCategory,
    startDateFilter,
    endDateFilter,
    txnSearchType,
    markerData,
  ]);

  useEffect(() => {
    dispatch(enableSwitcher());
    return () => {
      dispatch(disableSwitcher());
    };
  }, [markerData]);

  useEffect(() => {
    if (active?.length) {
      fetchFilterData();
    }
  }, [active]);

  return (
    <div className={containerClassName}>
      <div className=" h-full flex flex-col overflow-hidden">
        <div
          className={`hidden Qmd:flex ${showInnerSearchBar && "relative z-z-index-overlay"} ${
            popType === "BulkUploadDetails"
              ? ""
              : "min-h-navbar-breadcrumb-height"
          } bg-primary-nav`}
        ></div>
        <div className="relative z-z-index-overlay">
          <TopNavComponent
            filteredSearchProps={{
              setShowInnerSearchBar: setShowInnerSearchBar,
              showSearchBar: showSearch,
              isSearchDisabled: loading,
              onSearchInput: handleSearch,
              searchText: searchUserTextDebounce,
              searchPlaceholder: "Search bulk transactions",
              filterPlaceholder: "File name",
              filterItems: [
                {
                  name: "Search",
                  isMulti: false,
                  value: txnSearchType,
                  setValue: (val) => {
                    handleSubmit("search", val);
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    setTxnSearchType(val);
                  },
                  isDropdown: false,
                  isDisabled: loading,
                },
                {
                  name: "Category",
                  valueType: "string",
                  short_name: "Cat",
                  isMulti: false,
                  value: currentCategory,
                  setValue: (val) => {
                    handleSubmit("category", val);
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    setCurrentCategory(val);
                  },
                  isDropdown: true,
                  isDisabled: loading
                    ? true
                    : popType === "BulkUploadDetails"
                      ? true
                      : false,
                },
              ],
              filters: [
                {
                  name: "File status",
                  filterType: "dropdown",
                  variant: "single",
                  size: "small",
                  value: currentStatus,
                  dropdownPlaceHolder: "Select status",
                  isDisable: false,
                  options: ["processed", "processing", "failed"],
                  statusPop: true,
                  handleChange: (val) => {
                    handleSubmit("status", val);
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    setCurrentStatus(val);
                  },
                },
                {
                  name: "Date range",
                  filterType: "calender",
                  variant: "range",
                  size: "small",
                  value: startDateFilter && endDateFilter,
                  isDisable: false,
                  startDate: startDateFilter
                    ? new Date(
                        startDateFilter * IntervalConfiguration.intervalMedium,
                      )
                    : startDateFilter,
                  endDate: endDateFilter
                    ? new Date(
                        endDateFilter * IntervalConfiguration.intervalMedium,
                      )
                    : endDateFilter,
                  handleChange: (val) => {
                    handleSubmit("date", val);
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    handleDateChange(val);
                  },
                },
              ],

              isFilterClearAllDisabled: !(
                (startDateFilter && endDateFilter) ||
                currentStatus !== "" ||
                loading
              ),

              isSearchClearAllDisabled: !(popType === "BulkUploadDetails"
                ? currentCategory !== ""
                : !(currentCategory !== "") || !txnSearchType?.length),

              inputData: inputData,
              active: active,
              setActive: setActive,
              loadingData: loadingData,
              loading: loading,

              isSortDisabled: loading,
              isFilterDisabled: loading,
              setLoading: setLoadingData,
              isShowFilter: true,
            }}
            BottomHeader={"Post upload process"}
            BottomSubText={
              "Upon successful verification, transactions will be created and sent for approval. If transaction creation is unsuccessful, fix the errors, and upload the corrected data as a new file."
            }
          />
        </div>

        {/* Main content */}
        {showInnerSearchBar && (
          <div className="absolute bg-PopUp-BackDrop opacity-dark-opacity w-full h-full z-z-index-header"></div>
        )}
        <div
          className={`${contentClassName}`}
          style={{
            scrollPaddingTop: "var(--padding-md)",
            scrollPaddingBottom: "var(--padding-md)",
          }}
        >
          {loading ? (
            <div className="loader-container m-auto justify-center items-center flex w-full h-full">
              <Loader />
            </div>
          ) : viewAllData?.length > GlobalConfiguration.lengthCheckZero ? (
            <div
              className={` standard-card-alignment  gap-x-gap-sm gap-y-gap-md w-width-full`}
            >
              {viewAllData?.map((transaction) => (
                <TransactionCard
                  key={transaction.id}
                  transaction={transaction}
                  onNavigate={handleNavigate}
                  categoryMapper={categoryMapper}
                />
              ))}
            </div>
          ) : viewAllData?.length === GlobalConfiguration.lengthCheckZero &&
            (hasActiveFilters || currentStatus !== "" || txnSearchType) ? (
            <div className="flex flex-col items-center justify-center m-auto w-full h-full">
              <img
                src={
                  "https://q2pay.in/new_assets/graphics/no_data/no_data_found.svg"
                }
                alt="No accounts found"
                className={"w-graphic-width-md h-graphic-rectangle-height-md"}
              />
              <p className="bene-acc-no-beneaccount-text my-margin-sm">
                No data found.
              </p>

              <PrimaryButton
                enabledBgColor="var(--primary-nav-act)"
                btnText="Clear parameters"
                btnType="button"
                handleFunction={handleClearParams}
                enabledTextColor="var(--text-primary)"
                hoverOption="white"
              />
            </div>
          ) : (
            <div className="flex flex-col items-center justify-center m-auto h-full">
              <SVGComponent
                url={
                  "https://q2pay.in/new_assets/graphics/no_data/no_data_found.svg"
                }
                height={"var(--h-graphic-rectangle-height-md)"}
                width={"var(--graphic-width-md)"}
              />
              <p className="bene-acc-no-beneaccount-text my-margin-sm">
                No data found.
              </p>
            </div>
          )}
          <div
            style={{
              zIndex: "var(--z-index-modal)",
              width: "var(--width-full)",
              bottom: "var(--bottom-base)",
            }}
            className={`${showInnerSearchBar && " pointer-events-none opacity-dark-opacity"} ${loading || viewAllData?.length === GlobalConfiguration.lengthCheckZero ? "hidden" : "block"} ${popType === "BulkUploadDetails" ? " absolute pb-padding-base" : " fixed"}`}
          >
            {showInnerSearchBar && (
              <div className="absolute bg-PopUp-BackDrop opacity-dark-opacity w-full h-full z-z-index-header"></div>
            )}
            <div>
              <PaginationComponent
                handleSelect={handleSelect}
                selectedValue={selectedValue}
                data={mainData}
                pageSize={pageSize}
                dropdownOptions={dropdownOptions}
                handlePagination={handlePagination}
                currentPage={currentPage}
                setIsOpen={setIsOpen}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BulkTransactionViewAll;
